import { FilteredListViewModel } from "@frui.ts/datascreens";
import AccountingDocumentCandidateResponse from "./entities/accountingDocumentCandidateResponse";
import AccountingDocumentCandidateRowResponse from "./entities/accountingDocumentCandidateRowResponse";
import AccountingDocumentCandidateSearchRequest from "./entities/accountingDocumentCandidateSearchRequest";
import AccountingTemplateResponse from "./entities/accountingTemplateResponse";
import AdhocReportRequestResponse from "./entities/adhocReportRequestResponse";
import { ApprovalState } from "./entities/approvalState";
import BankAccount from "./entities/bankAccount";
import BankAccountBlacklist from "./entities/bankAccountBlacklist";
import BlacklistedEmailAddress from "./entities/blacklistedEmailAddress";
import EmailBlacklistFilter from "./entities/filters/emailBlacklistFilter";
import BankAccountEnum from "./entities/bankAccountEnum";
import { BankAccountFormatType } from "./entities/bankAccountFormatType";
import BankCodeType from "./entities/bankCodeType";
import BankExport from "./entities/bankExport";
import BulkExemption from "./entities/bulkExemption";
import ChangedChargeProperty from "./entities/changedChargeProperty";
import ChangeEmailRequest from "./entities/changeEmailRequest";
import ChargeChangeInitiator from "./entities/chargeChangeInitiator";
import ChargeChangeOrigin from "./entities/chargeChangeOrigin";
import ChargeChangeResponse from "./entities/chargeChangeResponse";
import ChargeChangesDuringValidityItemResponse from "./entities/chargeChangesDuringValidityItemResponse";
import ChargeDisplayStatus from "./entities/chargeDisplayStatus";
import ChargeHistoryResponse from "./entities/chargeHistoryResponse";
import ChargeOrderSearchResponse from "./entities/chargeOrderSearchResponse";
import ChargeOrderStatus from "./entities/chargeOrderStatus";
import ChargeRefundationStatus from "./entities/chargeRefundationStatus";
import ChargeResponse from "./entities/chargeResponse";
import ChargeType from "./entities/chargeType";
import ChargeValidity from "./entities/chargeValidity";
import CommissionForInvoiceResponse from "./entities/commissionForInvoiceResponse";
import Contact from "./entities/contact";
import CreditExposure from "./entities/creditExposure";
import CreditExposureState from "./entities/creditExposureState";
import CreditExposureType from "./entities/creditExposureType";
import CustomerRefundCandidateResponse from "./entities/customerRefundCandidateResponse";
import CustomerRefundCandidateTransferPaymentResponse from "./entities/customerRefundCandidateTransferPaymentResponse";
import Distributor from "./entities/distributor";
import DistributorIssuedPaymentRequestResponse from "./entities/distributorIssuedPaymentRequestResponse";
import DistributorPaymentRequestResponse from "./entities/distributorPaymentRequestResponse";
import DistributorsPaymentRequestStatus from "./entities/distributorPaymentRequestStatus";
import DistributorPaymentRequestType from "./entities/distributorPaymentRequestType";
import DistributorRefundCandidatesResponse from "./entities/distributorRefundCandidatesResponse";
import DistributorRefundDetailResponse from "./entities/distributorRefundDetailResponse";
import DistributorRefundResponse from "./entities/distributorRefundResponse";
import DistributorType from "./entities/distributorType";
import DistributorStatus from "./entities/distributorStatus";
import Enum from "./entities/enum";
import ExemptionReasonResponse from "./entities/exemptionReasonResponse";
import ExemptionResponse from "./entities/exemptionResponse";
import ExternalIdentityProvider from "./entities/externalIdentityProvider";
import ExternalReportResponse from "./entities/externalReportResponse";
import FeeType from "./entities/feeType";
import FuelType from "./entities/fuelType";
import GatewayExternalIdentType from "./entities/gatewayExternalIdentType";
import GatewayState from "./entities/gatewayState";
import GetExternalReportDetailResponse from "./entities/getExternalReportDetailResponse";
import GetInternalReportDetailResponse from "./entities/getInternalReportDetailResponse";
import GetSystemComponentOutagesRequest from "./entities/getSystemComponentOutagesRequest";
import InternalReportResponse from "entities/internalReportResponse";
import InternalTransferResponse from "./entities/internalTransferResponse";
import InternalTransfersRequest from "./entities/internalTransfersRequest";
import KioskStatus from "./entities/kioskStatus";
import LicensePlate from "./entities/licensePlate";
import Municipality from "./entities/municipality";
import Order from "./entities/order";
import OrderItem from "./entities/orderItem";
import OutgoingPayGatePaymentResponse from "./entities/outgoingPayGatePaymentResponse";
import OutgoingPayGatePaymentStatus from "./entities/outgoingPayGatePaymentStatus";
import OutgoingPayGateReversalPayment from "./entities/outgoingPayGateReversalPayment";
import OutgoingTransferPaymentResponse from "./entities/outgoingTransferPaymentResponse";
import OutgoingTransferPaymentStatus from "./entities/outgoingTransferPaymentStatus";
import PayGateRefundPaymentTemplate from "./entities/payGateRefundPaymentTemplate";
import PayGateRefundResponse from "./entities/payGateRefundResponse";
import PayGateSenderBankAccount from "./entities/payGateSenderBankAccountResponse";
import PayGateToTransferRefundPaymentTemplate from "./entities/payGateToTransferRefundPaymentTemplate";
import PayGateToTransferRefundResponse from "./entities/payGateToTransferRefundResponse";
import PayGateTransaction from "./entities/payGateTransaction";
import Payment from "./entities/payment";
import PaymentType from "./entities/paymentType";
import PermissionArea from "./entities/permissionArea";
import PermissionAreaWithFaultyCombinationsResponse from "./entities/permissionAreaWithFaultyCombinationsResponse";
import PermissionType from "./entities/permissionType";
import RefundApprovalType from "./entities/refundApprovalType";
import RefundApprovedResponse from "./entities/refundApprovedResponse";
import RefundDisplayStatus from "./entities/refundDisplayStatus";
import RefundForRefundOfRefundResponse from "./entities/refundForRefundOfRefundResponse";
import RefundPaymentType from "./entities/refundPaymentType";
import RefundTransferPayment from "./entities/refundTransferPaymentResponse";
import RefundType from "./entities/refundType";
import Region from "./entities/region";
import RejectedCustomerRefundCandidateResponse from "./entities/rejectedCustomerRefundCandidateResponse";
import RejectedCustomerRefundCandidateStatus from "./entities/rejectedCustomerRefundCandidateStatus";
import ReportRequestStatus from "./entities/reportRequestStatus";
import RevenueSourceType from "./entities/revenueSourceType";
import Road from "./entities/road";
import RoadType from "./entities/roadType";
import Role from "./entities/role";
import SourceType from "./entities/sourceType";
import SystemComponent from "./entities/systemComponent";
import Outage from "./entities/systemComponentOutageResponse";
import SystemComponentOutageState from "./entities/systemComponentOutageState";
import SystemComponentState from "./entities/systemComponentState";
import TransferOriginalPaymentDetailResponse from "./entities/transferOriginalPaymentDetailResponse";
import TransferRefundForRefundOfRefundPaymentTemplate from "entities/transferRefundForRefundOfRefundPaymentTemplate";
import TransferRefundPaymentTemplate from "./entities/transferRefundPaymentTemplate";
import TransferRefundResponse from "./entities/transferRefundResponse";
import TransferType from "./entities/transferType";
import UnpairedPayment from "./entities/unpairedPayment";
import UnpairedPaymentStatus from "./entities/unpairedPaymentStatus";
import User from "./entities/user";
import UserRole from "./entities/userRole";
import { UserType } from "./entities/userType";
import RefundDisplayType from "./entities/refundDisplayType";
import ChargeRefundResponse from "./entities/chargeRefundResponse";
import CustomerRefundPaymentType from "./entities/customerRefundPaymentType";
import SubLedgerReportResponse from "./entities/subLedgerReportResponse";
import SubLedgerReportSearchRequest from "./entities/subLedgerReportSearchRequest";
import CreditExposureNotificationStatus from "entities/creditExposureNotificationStatus";
import EnforcementTabletResponse from "entities/enforcementTabletResponse";
import DeadLetterTopicMessageResponse from "./entities/deadLetterTopicMessageResponse";
import DeadLetterTopicMessagesSearchRequest from "./entities/deadLetterTopicMessagesSearchRequest";
import KafkaDltMessageType from "./entities/kafkaDltMessageType";
import KafkaDltTopic from "./entities/kafkaDltTopic";
import DeadLetterTopicMessagesSearchResponse from "./entities/deadLetterTopicMessagesSearchResponse";
import DeadLetterTopicActionType from "./entities/deadLetterTopicActionType";
import DistributorRefundCandidateApprovalRejectionReason from "./entities/distributorRefundCandidateApprovalRejectionReason";
import EnforcementTabletUserResponse from "entities/enforcementTabletUserResponse";
import Kiosk from "entities/kiosk";
import GatewayResponse from "entities/gatewayResponse";
import LustrationReportResponse from "entities/lustrationReportResponse";
import ReportStatus from "entities/reportStatus";
import ExemptionRegistrationMethod from "entities/exemptionRegistrationMethod";
import ChargeOrderPaymentDisplayType from "entities/chargeOrderPaymentDisplayType";
import VehicleRegisterSynchronizationStatus from "entities/vehicleRegisterSynchronizationStatus";
import VehicleRegisterVehicleFuelType from "entities/vehicleRegisterVehicleFuelType";
import VehicleRegisterVehicleClassifiedFuelType from "entities/vehicleRegisterVehicleClassifiedFuelType";
import VehicleRegisterVehicleStatus from "entities/vehicleRegisterVehicleStatus";
import ChargePropertyChangeDisplayType from "entities/chargePropertyChangeDisplayType";
import ExemptionDetailGroupsResponse from "entities/exemptionDetailGroupsResponse";
import ExemptionChangeResponse from "entities/exemptionChangeResponse";
import ExemptionPropertyChangeDisplayType from "entities/exemptionPropertyChangeDisplayType";
import ExemptionChangeOrigin from "entities/exemptionChangeOrigin";
import SentEmailMessage from "entities/sentEmailMessageResponse";
import SentEmailMessageChargeResponse from "entities/sentEmailMessageChargeResponse";
import BulkExemptionPreviewItemResponse from "entities/bulkExemptionPreviewItemResponse";
import InternalReportRequest from "entities/internalReportRequest";
import VehicleRegistrationChangeChargeResponse from "entities/vehicleRegistrationChangeChargeResponse";
import VehicleRegistrationChangeExemptionResponse from "entities/vehicleRegistrationChangeExemptionResponse";
import BankAccountStatus from "entities/bankAccountStatus";
import VehicleRegisterVehicle from "entities/vehicleRegisterVehicleResponse";
import VehicleRegisterVehicleDetailResponse from "entities/vehicleRegisterVehicleDetailResponse";
import VehicleRegisterVehicleChangeResponse from "entities/vehicleRegisterVehicleChangeResponse";
import VehicleRegisterVehicleChangeOrigin from "entities/vehicleRegisterVehicleChangeOrigin";
import VehicleRegisterVehiclePropertyChangeDisplayType from "entities/vehicleRegisterVehiclePropertyChangeDisplayType";
import CardGatewayPayment from "entities/cardGatewayPaymentResponse";
import CardGatewayPaymentDetailResponse from "entities/cardGatewayPaymentDetailResponse";
import TransferPaymentResponse from "entities/transferPaymentResponse";
import TransferPaymentDetailResponse from "entities/transferPaymentDetailResponse";
import TerminalType from "entities/terminalType";
import NotifiableExemptionReasonSimpleList from "entities/notifiableExemptionReasonSimpleList";
import AccountBalanceCheckRequestsResponse from "entities/accountBalanceCheckRequestsResponse";
import AccountingDocumentsInventoriesResponse from "entities/acccountingDocumentsInventoriesResponse";

export enum Modules {
  administration = "administration",
  callCenter = "callCenter",
  enforcement = "enforcement",
  finance = "finance",
  timeCharges = "timeCharges",
  users = "users",
}

export const InternalEnumsMap = {
  approvalState: ApprovalState,
  bankAccountFormatType: BankAccountFormatType,
  bankCodeType: BankCodeType,
  bankAccountStatus: BankAccountStatus,
  customerRefundPaymentType: CustomerRefundPaymentType,
  creditExposureNotificationStatus: CreditExposureNotificationStatus,
  creditExposureState: CreditExposureState,
  creditExposureType: CreditExposureType,
  deadLetterTopicActionType: DeadLetterTopicActionType,
  distributorType: DistributorType,
  distributorStatus: DistributorStatus,
  distributorPaymentRequestStatus: DistributorsPaymentRequestStatus,
  distributorPaymentRequestType: DistributorPaymentRequestType,
  distributorRefundCandidateApprovalRejectionReason: DistributorRefundCandidateApprovalRejectionReason,
  feeType: FeeType,
  fuelType: FuelType,
  gatewayState: GatewayState,
  changedChargeProperty: ChangedChargeProperty,
  chargePropertyChangeDisplayType: ChargePropertyChangeDisplayType,
  exemptionPropertyChangeDisplayType: ExemptionPropertyChangeDisplayType,
  exemptionChangeOrigin: ExemptionChangeOrigin,
  chargeDisplayStatus: ChargeDisplayStatus,
  chargeValidity: ChargeValidity,
  chargeRefundationStatus: ChargeRefundationStatus,
  chargeChangeInitiator: ChargeChangeInitiator,
  chargeChangeOrigin: ChargeChangeOrigin,
  kioskStatus: KioskStatus,
  systemComponentOutageState: SystemComponentOutageState,
  outgoingPayGatePaymentStatus: OutgoingPayGatePaymentStatus,
  outgoingTransferPaymentStatus: OutgoingTransferPaymentStatus,
  chargeOrderStatus: ChargeOrderStatus,
  paymentType: PaymentType,
  paymentDisplayType: ChargeOrderPaymentDisplayType,
  vehicleRegisterSynchronizationStatus: VehicleRegisterSynchronizationStatus,
  vehicleRegisterVehicleStatus: VehicleRegisterVehicleStatus,
  vehicleRegisterVehicleFuelType: VehicleRegisterVehicleFuelType,
  vehicleRegisterVehicleClassifiedFuelType: VehicleRegisterVehicleClassifiedFuelType,
  permissionType: PermissionType,
  refundType: RefundType,
  refundPaymentType: RefundPaymentType,
  refundDisplayType: RefundDisplayType,
  refundDisplayStatus: RefundDisplayStatus,
  refundApprovalType: RefundApprovalType,
  rejectedCustomerRefundCandidateStatus: RejectedCustomerRefundCandidateStatus,
  reportRequestStatus: ReportRequestStatus,
  reportStatus: ReportStatus,
  revenueSourceType: RevenueSourceType,
  roadType: RoadType,
  sourceType: SourceType,
  systemComponentState: SystemComponentState,
  kafkaDltMessageType: KafkaDltMessageType,
  kafkaDltTopic: KafkaDltTopic,
  transferType: TransferType,
  unpairedPaymentStatus: UnpairedPaymentStatus,
  userType: UserType,
  terminalType: TerminalType,
  vehicleRegisterVehicleChangeOrigin: VehicleRegisterVehicleChangeOrigin,
  vehicleRegisterVehiclePropertyChangeDisplayType: VehicleRegisterVehiclePropertyChangeDisplayType,
  exemptionRegistrationMethod: ExemptionRegistrationMethod,
} as const;

export const ExternalEnums = [
  "accounting_templates",
  "bank_accounts",
  "external_identity_providers",
  "kiosk",
  "system_components",
  "gateways",
] as const;

export const SimpleListEnums = [
  "bank_accounts",
  "payment_templates",
  "paygate_refund_payment_templates",
  "transfer_refund_payment_templates",
  "paygate_to_transfer_refund_payment_templates",
  "refund_for_refund_of_refund_payment_templates",
  "municipalities",
  "notifiable_exemption_reasons",
  "distributors",
  "regions",
  "roads",
  "inventory_accounts",
] as const;

export const SystemEnums = ["countries", "fuel_types", "charge_types", "exemption_reasons", "payment_templates"] as const;

export const EntitiesMap = {
  accountingDocumentCandidate: AccountingDocumentCandidateResponse,
  accountingDocumentCandidateRowResponse: AccountingDocumentCandidateRowResponse,
  accountingDocumentCandidateSearchRequest: AccountingDocumentCandidateSearchRequest,
  accountingTemplateResponse: AccountingTemplateResponse,
  adhocReportRequestResponse: AdhocReportRequestResponse,
  bankAccount: BankAccount,
  balance: AccountBalanceCheckRequestsResponse,
  documentsInventory: AccountingDocumentsInventoriesResponse,
  bankAccountEnum: BankAccountEnum,
  bankAccountBlacklist: BankAccountBlacklist,
  emailBlacklist: BlacklistedEmailAddress,
  emailBlacklistFilter: EmailBlacklistFilter,
  bankExport: BankExport,
  bulkExemption: BulkExemption,
  bulkExemptionPreviewItem: BulkExemptionPreviewItemResponse,
  country: Enum,
  commissionForInvoice: CommissionForInvoiceResponse,
  contact: Contact,
  creditExposure: CreditExposure,
  customerRefundCandidate: CustomerRefundCandidateResponse,
  customerRefundCandidateTransferPaymentResponse: CustomerRefundCandidateTransferPaymentResponse,
  deadLetterTopicsSearch: DeadLetterTopicMessageResponse,
  deadLetterTopicsActionSearch: DeadLetterTopicMessagesSearchResponse,
  distributor: Distributor,
  distributorIssuedPaymentRequest: DistributorIssuedPaymentRequestResponse,
  distributorRefundResponse: DistributorRefundResponse,
  distributorRefundDetailResponse: DistributorRefundDetailResponse,
  distributorPaymentRequest: DistributorPaymentRequestResponse,
  distributorRefundCandidatesResponse: DistributorRefundCandidatesResponse,
  enum: Enum,
  enforcementTablet: EnforcementTabletResponse,
  enforcementUser: EnforcementTabletUserResponse,
  exemption: ExemptionResponse,
  exemptionEdit: ExemptionResponse,
  emailMessage: SentEmailMessage,
  emailMessageCharge: SentEmailMessageChargeResponse,
  exemptionReason: ExemptionReasonResponse,
  notifiableExemptionReasons: NotifiableExemptionReasonSimpleList,
  externalIdentityProvider: ExternalIdentityProvider,
  externalReportResponse: ExternalReportResponse,
  getExternalReportDetailResponse: GetExternalReportDetailResponse,
  getInternalReportDetailResponse: GetInternalReportDetailResponse,
  changeEmailRequest: ChangeEmailRequest,
  exemptionDetail: ExemptionDetailGroupsResponse,
  exemptionChanges: ExemptionChangeResponse,
  charge: ChargeResponse,
  changeVehicleCharge: VehicleRegistrationChangeChargeResponse,
  changeVehicleExemption: VehicleRegistrationChangeExemptionResponse,
  chargeType: ChargeType,
  chargeOrderSearch: ChargeOrderSearchResponse,
  chargeHistory: ChargeHistoryResponse,
  chargeRefund: ChargeRefundResponse,
  chargeChange: ChargeChangeResponse,
  chargeChangesDuringValidityItemResponse: ChargeChangesDuringValidityItemResponse,
  paymentCardGateway: CardGatewayPayment,
  paymentCardGatewayDetail: CardGatewayPaymentDetailResponse,
  paymentBankTransfer: TransferPaymentResponse,
  paymentBankTransferDetail: TransferPaymentDetailResponse,
  gateway: GatewayResponse,
  gatewayExternalIdentType: GatewayExternalIdentType,
  internalReport: InternalReportRequest,
  internalReportResponse: InternalReportResponse,
  internalTransfer: InternalTransferResponse,
  internalTransfersRequest: InternalTransfersRequest,
  kiosk: Kiosk,
  kioskType: Enum,
  licensePlate: LicensePlate,
  lustrationReport: LustrationReportResponse,
  municipality: Municipality,
  order: Order,
  orderItem: OrderItem,
  outage: Outage,
  outgoingTransferPayment: OutgoingTransferPaymentResponse,
  outgoingPayGatePayment: OutgoingPayGatePaymentResponse,
  outgoingPayGateReversalPayment: OutgoingPayGateReversalPayment,
  payment: Payment,
  transferRefundForRefundOfRefundPaymentTemplate: TransferRefundForRefundOfRefundPaymentTemplate,
  transferRefundPaymentTemplate: TransferRefundPaymentTemplate,
  payGateRefundPaymentTemplate: PayGateRefundPaymentTemplate,
  payGateToTransferRefundPaymentTemplate: PayGateToTransferRefundPaymentTemplate,
  payGateRefund: PayGateRefundResponse,
  payGateToTransferRefund: PayGateToTransferRefundResponse,
  payGateSenderBankAccount: PayGateSenderBankAccount,
  payGateTransaction: PayGateTransaction,
  permissionArea: PermissionArea,
  permissionAreaWithFaultyCombinationsResponse: PermissionAreaWithFaultyCombinationsResponse,
  region: Region,
  road: Road,
  role: Role,
  refundApprovedResponse: RefundApprovedResponse,
  refundForRefundOfRefund: RefundForRefundOfRefundResponse,
  rejectedCustomerRefundCandidate: RejectedCustomerRefundCandidateResponse,
  subLedgerReportSearchRequest: SubLedgerReportSearchRequest,
  subLedgerReportResponse: SubLedgerReportResponse,
  systemComponent: SystemComponent,
  systemComponentOutageRequest: GetSystemComponentOutagesRequest,
  deadLetterTopicMessagesSearchRequest: DeadLetterTopicMessagesSearchRequest,
  transferRefund: TransferRefundResponse,
  transferRefundPayment: RefundTransferPayment,
  transferOriginalPaymentDetailResponse: TransferOriginalPaymentDetailResponse,
  unpairedPayment: UnpairedPayment,
  user: User,
  userRole: UserRole,
  vehicleRegisterVehicle: VehicleRegisterVehicle,
  vehicleRegisterHistories: VehicleRegisterVehicleChangeResponse,
  vehicleRegisterDetail: VehicleRegisterVehicleDetailResponse,
} as const;

export type Entities = (typeof EntitiesMap)[keyof typeof EntitiesMap];

export type EntityNames = keyof typeof EntitiesMap;

export const KnownErrors = {
  AD_HOC_REPORT_IS_IN_PROGRESS: "AD_HOC_REPORT_IS_IN_PROGRESS",
  REQUEST_FORBIDDEN: "REQUEST_FORBIDDEN",
  REQUEST_MODEL_VALIDATION_FAILED: "REQUEST_MODEL_VALIDATION_FAILED",
  CANCELLATION_FILE_CONTAINS_NO_CHARGE_ORDERS: "CANCELLATION_FILE_CONTAINS_NO_CHARGE_ORDERS",
  CANCELLATION_FILE_PARSING_FAILED: "CANCELLATION_FILE_PARSING_FAILED",
  COUNTRY_NOT_FOUND: "COUNTRY_NOT_FOUND",
  CUSTOMER_REFUND_CANDIDATE_NOT_FOUND: "CUSTOMER_REFUND_CANDIDATE_NOT_FOUND",
  VEHICLE_CHARGE_REGISTRATION_NOT_FOUND: "VEHICLE_CHARGE_REGISTRATION_NOT_FOUND",
  PAYMENT_IS_NON_REFUNDABLE: "PAYMENT_IS_NON_REFUNDABLE",
  CHARGE_ORDER_NOT_FOUND: "CHARGE_ORDER_NOT_FOUND",
  CHARGE_NOT_FOUND: "CHARGE_NOT_FOUND",
  PAYMENT_NOT_FOUND: "PAYMENT_NOT_FOUND",
  SOURCE_TYPE_NOT_ALLOWED: "SOURCE_TYPE_NOT_ALLOWED",
  APPROVAL_INVALID: "APPROVAL_INVALID",
  VEHICLE_SEM_REGISTRATIONS_ZIP_CONTENT_INVALID: "VEHICLE_SEM_REGISTRATIONS_ZIP_CONTENT_INVALID",
  APPROVAL_ROLES_INVALID: "APPROVAL_ROLES_INVALID",
  INVALID_FILE_CONTENT: "INVALID_FILE_CONTENT",
  UNPAIRED_PAYMENT_NOT_FOUND: "UNPAIRED_PAYMENT_NOT_FOUND",
  REFUND_EXPORT_NOT_FOUND: "REFUND_EXPORT_NOT_FOUND",
  TRANSFER_REFUND_NOT_FOUND: "TRANSFER_REFUND_NOT_FOUND",
  REFUND_NOT_FOUND: "REFUND_NOT_FOUND",
  REFUND_PAYMENT_CHANGE_NOT_ALLOWED: "REFUND_PAYMENT_CHANGE_NOT_ALLOWED",
  REFUND_COUNTERPARTY_OVERRIDE_INVALID: "REFUND_COUNTERPARTY_OVERRIDE_INVALID",
  REFUND_COUNTERPARTY_OVERRIDE_DENIED: "REFUND_COUNTERPARTY_OVERRIDE_DENIED",
  REFUND_COUNTERPARTY_OVERRIDE_AFTER_SEPA_TRANSFER_INVALID: "REFUND_COUNTERPARTY_OVERRIDE_AFTER_SEPA_TRANSFER_INVALID",
  REJECTED_CUSTOMER_REFUND_CANDIDATE_ALREADY_RECREATED: "REJECTED_CUSTOMER_REFUND_CANDIDATE_ALREADY_RECREATED",
  PAY_GATE_REFUND_NOT_FOUND: "PAY_GATE_REFUND_NOT_FOUND",
  CHARGE_REFUND_ALREADY_EXISTS: "CHARGE_REFUND_ALREADY_EXISTS",
  PAYMENT_REFUND_ALREADY_EXISTS: "PAYMENT_REFUND_ALREADY_EXISTS",
  APPROVAL_ALREADY_EXISTS: "APPROVAL_ALREADY_EXISTS",
  PAYMENT_UNPAIRABLE: "PAYMENT_UNPAIRABLE",
  PAYMENT_UNPAIRABLE_WITH_ORDER: "PAYMENT_UNPAIRABLE_WITH_ORDER",
  PAYMENT_REFUND_ALREADY_APPROVED: "PAYMENT_REFUND_ALREADY_APPROVED",
  KIOSK_CHARGE_NONREFUNDABLE: "KIOSK_CHARGE_NONREFUNDABLE",
  DISTRIBUTOR_NOT_FOUND: "DISTRIBUTOR_NOT_FOUND",
  DISTRIBUTORS_PAYMENT_REQUEST_NOT_FOUND: "DISTRIBUTORS_PAYMENT_REQUEST_NOT_FOUND",
  DISTRIBUTOR_CHARGE_REFUND_BANK_ACCOUNT_REQUIRED: "DISTRIBUTOR_CHARGE_REFUND_BANK_ACCOUNT_REQUIRED",
  DISTRIBUTORS_EXPORT_FILE_CONTAINS_TOO_MANY_ROWS: "DISTRIBUTORS_EXPORT_FILE_CONTAINS_TOO_MANY_ROWS",
  DISTRIBUTORS_EXPORT_FILE_CONTAINS_NO_CHARGE_ORDERS: "DISTRIBUTORS_EXPORT_FILE_CONTAINS_NO_CHARGE_ORDERS",
  DISTRIBUTORS_EXPORT_FILE_CONTAINS_INVALID_ORDERS: "DISTRIBUTORS_EXPORT_FILE_CONTAINS_INVALID_ORDERS",
  DISTRIBUTORS_EXPORT_FILE_PARSING_FAILED: "DISTRIBUTORS_EXPORT_FILE_PARSING_FAILED",
  DISTRIBUTOR_PAYMENT_REQUEST_HAS_EXISTING_REFUND_CANDIDATES: "DISTRIBUTOR_PAYMENT_REQUEST_HAS_EXISTING_REFUND_CANDIDATES",
  DISTRIBUTOR_PAYMENT_REQUEST_HAS_EXISTING_REFUNDS: "DISTRIBUTOR_PAYMENT_REQUEST_HAS_EXISTING_REFUNDS",
  RESOURCE_UNIQUE_PROPERTY_VIOLATION: "RESOURCE_UNIQUE_PROPERTY_VIOLATION",
  RESOURCE_NOT_FOUND: "RESOURCE_NOT_FOUND",
  REFUND_FOR_NEW_BLACKLISTED_BANK_ACCOUNT_EXISTS: "REFUND_FOR_NEW_BLACKLISTED_BANK_ACCOUNT_EXISTS",
  BLACKLISTED_BANK_ACCOUNT_ALREADY_EXISTS: "BLACKLISTED_BANK_ACCOUNT_ALREADY_EXISTS",
  BLACKLISTED_BANK_ACCOUNT_NOT_FOUND: "BLACKLISTED_BANK_ACCOUNT_NOT_FOUND",
  MONTHLY_REVENUE_MONTH_INVALID: "MONTHLY_REVENUE_MONTH_INVALID",
  MONTHLY_EXPENSE_MONTH_INVALID: "MONTHLY_EXPENSE_MONTH_INVALID",
  COMBINATION_OF_ROLES_FORBIDDEN: "COMBINATION_OF_ROLES_FORBIDDEN",
  DISTRIBUTOR_REFUND_CANDIDATES_ARE_NOT_ALL_NEW: "DISTRIBUTOR_REFUND_CANDIDATES_ARE_NOT_ALL_NEW",
  SYSTEM_COMPONENT_OUTAGE_VALIDITY_RANGE_CONFLICT: "SYSTEM_COMPONENT_OUTAGE_VALIDITY_RANGE_CONFLICT",
  EXTERNAL_REPORT_IS_IN_PROGRESS: "EXTERNAL_REPORT_IS_IN_PROGRESS",
  USER_ROLE_ALREADY_EXISTS: "USER_ROLE_ALREADY_EXISTS",
  ROLE_ALREADY_EXISTS: "ROLE_ALREADY_EXISTS",
  USER_ALREADY_EXISTS: "USER_ALREADY_EXISTS",
  USER_CREATION_FAILED: "USER_CREATION_FAILED",
  CHARGE_WITH_EXISTING_ACTIVE_REFUND_CANDIDATE_IS_NOT_REFUNDABLE:
    "CHARGE_WITH_EXISTING_ACTIVE_REFUND_CANDIDATE_IS_NOT_REFUNDABLE",
  ENFORCEMENT_USER_WITH_GIVEN_CODE_ALREADY_EXISTS: "ENFORCEMENT_USER_WITH_GIVEN_CODE_ALREADY_EXISTS",
  EVENT_OCCURRED_DATE_IS_TOO_FAR_IN_THE_PAST: "EVENT_OCCURRED_DATE_IS_TOO_FAR_IN_THE_PAST",
  EVENT_OCCURRED_DATE_CANNOT_BE_IN_THE_FUTURE: "EVENT_OCCURRED_DATE_CANNOT_BE_IN_THE_FUTURE",
  EXEMPTION_UNCHANGED: "EXEMPTION_UNCHANGED",
  CHARGE_FUEL_TYPE_UNCHANGED: "CHARGE_FUEL_TYPE_UNCHANGED",
  VALID_UNTIL_CHANGE_DENIED: "VALID_UNTIL_CHANGE_DENIED",
  VALID_UNTIL_INVALID: "VALID_UNTIL_INVALID",
  VALID_SINCE_INVALID: "VALID_SINCE_INVALID",
  EXEMPTION_FULL_CHANGE_DENIED: "EXEMPTION_FULL_CHANGE_DENIED",
  EXEMPTION_DELETION_DENIED: "EXEMPTION_DELETION_DENIED",
};

export const SilentErrors = {
  SUB_LEDGER_REPORT_FILTER_CHARGE_ORDERS_NOT_FOUND: "SUB_LEDGER_REPORT_FILTER_CHARGE_ORDERS_NOT_FOUND",
  SUB_LEDGER_REPORT_FILTER_CHARGES_NOT_FOUND: "SUB_LEDGER_REPORT_FILTER_CHARGES_NOT_FOUND",
  SUB_LEDGER_REPORT_FILTER_TRANSFER_PAYMENTS_NOT_FOUND: "SUB_LEDGER_REPORT_FILTER_TRANSFER_PAYMENTS_NOT_FOUND",
  SUB_LEDGER_REPORT_FILTER_PAYGATE_PAYMENTS_NOT_FOUND: "SUB_LEDGER_REPORT_FILTER_PAYGATE_PAYMENTS_NOT_FOUND",
  SUB_LEDGER_REPORT_FILTER_SUMMARY_ACCOUNTING_DOCUMENTS_NOT_FOUND:
    "SUB_LEDGER_REPORT_FILTER_SUMMARY_ACCOUNTING_DOCUMENTS_NOT_FOUND",
};

export type KnownErrorCodes =
  | keyof typeof KnownErrors
  | "internalServerError"
  | "communicationServerError"
  | "payloadTooLarge"
  | "unexpectedError";

export const newNavigationName = "new";
export const detailNavigationName = "detail";
export const editationNavigationName = "edit";
export const deleteNavigationName = "delete";
export const cancelNavigationName = "cancel";
export const pageSize = (FilteredListViewModel.defaultPageSize = 15);
export const startOfEDAZ = new Date("2020-11-01");
export const startOfEDAZEshop = new Date("2020-12-01");
export const startOfEDAZDistribution = new Date("2020-11-28");

export const apiUrl = process.env.REACT_APP_API_URL ?? "";
export const apiVersion = process.env.REACT_APP_API_VERSION ?? "";
export const apiPathRegex = "api/v%version%";
export const authApiUrl = process.env.REACT_APP_AUTH_API_URL ?? "";
export const authApiVersion = process.env.REACT_APP_AUTH_API_VERSION ?? "";
export const openIdConnectUrl = process.env.REACT_APP_OPEN_ID_CONNECT_URL ?? "";
export const redirectUri = process.env.REACT_APP_REDIRECT_URI ?? "";
export const contentServerUrl = process.env.REACT_APP_CONTENT_SERVER_URL ?? "";
export const clientId = process.env.REACT_APP_CLIENT_ID ?? "backoffice.client";
export const clientSecret = process.env.REACT_APP_CLIENT_SECRET ?? "1lVujIRVhP";
export const scope = process.env.REACT_APP_OPEN_ID_SCOPE ?? "backoffice.api";
export const accessTokenKey = "Access-token";
export const refreshTokenKey = "Refresh-token";
export const sentryDSN = process.env.REACT_APP_SENTRY_DSN;
export const sentryTracesSampleRate = parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE ?? "0.2");
export const environment = process.env.REACT_APP_ENVIRONMENT ?? "Dev";
export const appVersion = process.env.REACT_APP_VERSION;
